import { render } from "./AcademicOfficesModule.vue?vue&type=template&id=b8cc832c&scoped=true"
import script from "./AcademicOfficesModule.vue?vue&type=script&lang=js"
export * from "./AcademicOfficesModule.vue?vue&type=script&lang=js"

import "./AcademicOfficesModule.vue?vue&type=style&index=0&id=b8cc832c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b8cc832c"

export default script